export default __webpack_public_path__ + "static/media/sampleReport2.0b3c7054.png";